module.exports = __webpack_public_path__ + "static/media/pw-win-percent-icon.686ef33b.svg";